import { render, staticRenderFns } from "./PatternDependencies.vue?vue&type=template&id=6b23b213&scoped=true&"
import script from "./PatternDependencies.vue?vue&type=script&lang=js&"
export * from "./PatternDependencies.vue?vue&type=script&lang=js&"
import style0 from "./PatternDependencies.vue?vue&type=style&index=0&id=6b23b213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b23b213",
  null
  
)

export default component.exports